import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { AccountService, IAccount } from "./account.service";
import { ConstantsService } from "./constantsService";
import { CurrentUserService } from "./currentUser.service";
import { ILoginResponse } from "./login.service.ajs";
import { NavigationService } from "./navigation.service";
import { SessionService } from "./session.service";

@Injectable({
    providedIn: "root"
})
export class LoginService {

    private tokenUrl: string;
    constructor(private readonly http: HttpClient,
        private readonly accountService: AccountService,
        private readonly constantsService: ConstantsService,
        private readonly currentUserService: CurrentUserService,
        private readonly navigationService: NavigationService,
        private readonly sessionService: SessionService) {
        this.tokenUrl = this.constantsService.getTokenUrl(); }

    sendForgotPasswordEmail(email: string): Observable<any> {
        return this.http.post<any>(`/api/forgottenpassword`, JSON.stringify(email));
    }

    loginWithToken(token: string, flushExistingSession = false): Observable<ILoginResponse> {
        return this.login("---", token, flushExistingSession);
    }

    login(username: string, password: string, flushExistingSession = false): Observable<ILoginResponse> {
        if (flushExistingSession) {
            // Flush any existing session
            this.sessionService.clearAllCachesAndSessions();
        }

        const data = `grant_type=password&username=${username}&password=${encodeURIComponent(password)}`;
        const headers = new HttpHeaders({
                "Content-Type": "application/x-www-form-urlencoded"
        })

        return this.http.post<ILoginResponse>(this.tokenUrl, data, { headers }).pipe(
            tap(loginResponse => {
                this.storeLoginSession(loginResponse);
            })
        );
    }

    switchAccount(accountId: number, reloadOnSuccess = false): Promise<ILoginResponse> {
        return this.sessionService.switchAccount(accountId)
            .then(() => {
                this.currentUserService.getCurrentUser(true).then(() => {
                    this.accountRedirect(reloadOnSuccess);
                });
            }) as Promise<ILoginResponse>;

    }

    accountRedirect(reload = false): Promise<void> {
        return this.getAllUserAndAccountSettings(true).then((accountData) => {
            this.navigationService.goToDefaultPage(accountData, reload);
        });
    }

    getAllUserAndAccountSettings(invalidateCache = true): Promise<IAccount> {
        return this.currentUserService.getCurrentUser().then(currentUser => {
            // We chain these, as we need current user BEFORE we get account data
            return this.accountService.getAccountData(invalidateCache)
                .then(accountData => {

                    return this.sessionService.getAllUserAndAccountSettings()
                        .then(() => {
                            return accountData;
                        })
                        .finally(() => {
                            return accountData;
                        });
                })
                .finally(() => {
                    this.currentUserService.performUserValidationChecks();
                });
        }) as Promise<IAccount>;
    }

    //--

    private storeLoginSession(loginResponse: ILoginResponse) {
        if (loginResponse != null && loginResponse.access_token.length > 0) {
            this.sessionService.setStorage(loginResponse);
        }
        else {
            console.warn("Didnt store login response...");
        }
    }
}
